export default __webpack_public_path__ + "static/media/partnershipIcon1.b89fa99e.webp";